const actions = {
  SET_STATE: "user/SET_STATE",
  LIST: "user/LIST",
  CREATE: "user/CREATE",
  DETAIL: "user/DETAIL",
  UPDATE: "user/UPDATE",
  DELETE: "user/DELETE",
};

export default actions;
